import { ArrowForward } from '@mui/icons-material';
import { Box } from '@mui/material';
import {
  VssPlan,
  VssPlanType,
  VssPublicAccount
} from '@portal-middleware/hooks';
import { Link, ScreenReaderOnlyText, Text } from '@vestwell-frontend/ui';

import { FC } from 'react';

export type GiftInfoProps = {
  plan: VssPlan;
  accountPublic: VssPublicAccount;
  mt?: number;
  mb?: number;
};
export const GiftInfo: FC<GiftInfoProps> = ({
  plan,
  accountPublic,
  mt = 4,
  mb = 4
}) => (
  <Text mb={mb} mt={mt} variant='g1'>
    A gift contribution to {accountPublic?.firstName}
    {accountPublic?.firstName?.endsWith('s') ? '’' : '’s'}{' '}
    {plan?.type === VssPlanType.able && (
      <>
        {plan?.shortName} account can help pay for everyday expenses and care
        down the road
      </>
    )}
    {plan?.type === VssPlanType.collegeSavings && (
      <>{plan?.shortName} account can help pay for future education</>
    )}
    . Plus, it's easier than wrapping a present.
    <Box mt={2}>
      <Link target='_blank' to={plan?.urls?.giftingFaqs}>
        Learn more about gifting{' '}
        <ArrowForward fontSize='small' role='presentation' />
        <ScreenReaderOnlyText> (opens in new tab)</ScreenReaderOnlyText>
      </Link>{' '}
    </Box>
  </Text>
);
